import { registerInspectionError } from 'lib/register-inspection-error'
import { Component, ErrorInfo } from 'react'
import { UnexpectedErrorMessage } from './UnexpectedError'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)

    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    registerInspectionError(error, errorInfo)
  }

  render() {
    // Check if the error is thrown
    if (this.state.hasError) {
      return <UnexpectedErrorMessage />
    }

    // Return children components in case of no error

    return this.props.children
  }
}

export default ErrorBoundary
